module.exports = __webpack_public_path__ + "img/pic_do01@2x.26e36ae2.png";